import { FC, useCallback, useMemo } from 'react'
import { Table } from '@wmgtech/legato'

import { ActionButton } from 'components/ActionButton'
import { ColumnsType, IMediaBuyer, ModalForm, useAdmin } from 'modules/Admin'
import { useMediaBuyer } from '../../services/useMediaBuyer'
import { SkeletonTable } from 'components'
import { useConfirmation } from 'components/Confirmation'
import styles from './mediabuyer.module.scss'

interface IMediaBuyerInput {
  name: string
  id?: string
}

export const MediaBuyer: FC = () => {
  const { mediaBuyers, loading, createMediaBuyer, deleteMediaBuyer, updateMediaBuyer } = useMediaBuyer()

  const { handleEdit } = useAdmin()

  const onSubmit = useCallback(
    async ({ id, name }: IMediaBuyerInput) => {
      if (typeof id === 'undefined') {
        return createMediaBuyer(name)
      }
      return updateMediaBuyer(id, name )
    },
    [createMediaBuyer, updateMediaBuyer],
  )

  const { onConfirm, element } = useConfirmation(
    deleteMediaBuyer,
    (message) => (<>Are you sure you want to delete advertiser <b>{message}</b> ?</>),
    'Delete',
  )

  const getAlertMessage = useCallback((record: any) => {
    const labels = record?.labels?.map(({ name }: { name: string }) => <p>{name}</p>)
    const campaigns = record?.campaigns?.map(({ name }: { name: string }) => <p>{name}</p>)
    return (
      <>
        <p style={{ marginBottom: '10px' }}>
          {!!record?.labels?.length && (
            <>
              The media buyer <b>{record.name}</b> is assigned to labels: {labels}
            </>
          )}
        </p>
        <p style={{ marginBottom: '10px' }}>
          {!!record?.campaigns?.length && (
            <>
              The media buyer <b>{record.name}</b> is assigned to campaigns: {campaigns}
            </>
          )}
        </p>
      </>
    )
  }, [])
  //
  const columns = useMemo<ColumnsType<IMediaBuyer>[]>(
    () => [
      {
        dataIndex: 'name',
        title: 'Name',
        key: 'name',
        sortable: false,
        align: 'left',
        width: '30%',
      },
      {
        dataIndex: 'labels',
        title: 'Assigned to Label',
        key: 'labels',
        sortable: false,
        align: 'left',
        render: (el: any, record: any) => (<>{el?.map((a: IMediaBuyer) => a.name).join(', ')}</>),
      },
      {
        dataIndex: 'action',
        key: 'action',
        sortable: false,
        width: '63px',
        align: 'center',
        render: (el: any, record: any) => (
          <ActionButton
            handleEdit={() => handleEdit((record as any))}
            handleDelete={() => onConfirm({
              data: record.id,
              message: `${record.name}`,
              ...((record?.campaigns?.length || record?.labels?.length) && { subMessage: getAlertMessage(record) }),
            })}
          />
        ),
      },
    ],
    [handleEdit, onConfirm, getAlertMessage],
  )

  return (
    <div className={styles.container}>
      {
        !loading ? (
          <Table
            data={mediaBuyers || []}
            columns={columns}
            rowKey={({ id }) => id}
            pagination={false}
          />
        ) : <SkeletonTable lines={10}/>
      }
      {element}
      <ModalForm onSubmit={onSubmit}/>
    </div>
  )
}
